module.exports = __webpack_public_path__ + "media/Goals/CutBackOnPlastic-dc3bc576.svg";